import React from "react";
import { GiftIcon } from "lucide-react";
import { bonuses } from "../data/content";
export function Bonuses() {
  return <section className="px-5 py-20" data-id="element-12" data-mp="pioa4qcb3aan">
      <div className="mx-auto max-w-3xl" data-id="element-13" data-mp="plsilzwt0s74">
        <h2 className="text-center font-display text-4xl uppercase text-cream sm:text-5xl" data-id="element-14" data-mp="avuzvzhn8upb">
          + 6 bonus <span className="text-gold" data-id="element-15" data-mp="ft4pbf5196d5">offerts</span>
        </h2>
        <p className="mt-4 text-center font-serif text-xl italic text-mute" data-id="element-16" data-mp="1uesm0m4l8pb">Inclus gratuitement avec votre commande aujourd'hui.</p>
        <ul className="mt-10 divide-y divide-line rounded-2xl border border-line bg-panel" data-id="element-17" data-mp="5x1nybi09br9">
          {bonuses.map((b, i) => <li key={b.title} className="flex items-center gap-4 px-5 py-4 sm:px-6" data-id="element-18" data-mp="3o3fzy4wprbn0" data-mpi={i}>
              <GiftIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden data-id="element-19" data-mp="3t1hlqxlixp26" />
              <span className="flex-1 text-cream" data-id="element-20" data-mp="1m9yw7cbpeuxj">
                <span className="mr-2 text-sm font-bold text-gold" data-id="element-21" data-mp="1m85qbz8x0eql">BONUS {i + 1}</span>
                {b.title}
              </span>
              <span className="text-sm text-mute line-through" data-id="element-22" data-mp="3idwofjt8hcl8">{b.value}</span>
              <span className="text-sm font-bold text-gold" data-id="element-23" data-mp="3dfd39lmgs4tx">OFFERT</span>
            </li>)}
        </ul>
      </div>
    </section>;
}